<template>
  <div class="main">
    <div class="logo">
      <p>正在跳中...</p>
    </div>
  </div>
</template>

<script>
import { generateschemeV2 } from "@/api/common";
import qs from "qs";
export default {
  data() {
    return {};
  },
  created() {
    if (this.$route.query?.appId && this.$route.query?.path) {
      const {appId,path,env_version="release",expire_type,expire_time=30,expire_interval=30,...params} = this.$route.query
      const data = {
        appId,
        path,
        env_version,
        query: qs.stringify(params)
      }

      // 用户传入 expire_type 时才添加失效相关参数
      if (expire_type !== undefined) {
        const type = Number(expire_type)
        data.expire_type = type
        if (type === 0 && expire_time) {
          data.expire_time = Number(expire_time)
        }
        if (type === 1 && expire_interval) {
          data.expire_interval = Number(expire_interval)
        }
      }


      generateschemeV2(data).then((res) => { 
        if (res.code == 0 && res.data) {
          location.href = res.data;
        } else {
          this.$dialog.alert({ message: "获取小程序链接失败！" + res.msg });
        }
      });
    }else {
      this.$dialog.alert({ message: "query中缺少url参数" });
    }
  },
  methods: {}
};
</script>

<style lang="scss" scoped>
.main {
  .logo {
    padding-top: 50px;
    text-align: center;

    p {
      font-size: 14px;
    }
  }
}
</style>
